import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { ArrowUpRight } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Payment from "@/pages/Payment";
import Contact from "@/pages/Contact";
import Faq from "@/pages/Faq";
import CustomerCare from "@/pages/CustomerCare";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Sitemap from "@/pages/Sitemap";
import Admin from "@/pages/Admin";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const MobilePayBar = () => (
  <>
    <div className="h-[76px] md:hidden" aria-hidden="true" />
    <div
      className="fixed bottom-0 inset-x-0 z-50 md:hidden border-t border-slate-900/10 bg-white/90 backdrop-blur-xl px-4 py-3"
      data-testid="mobile-pay-bar"
    >
      <a
        href="https://my.blytzpay.com/#/merchant/7acdb786-1f15-4eca-aff5-f4b1fea02516/login"
        data-testid="mobile-pay-bar-button"
        className="flex items-center justify-center gap-2 rounded-full bg-ember w-full py-3.5 font-bold text-white"
      >
        Pay Now <ArrowUpRight size={18} />
      </a>
    </div>
  </>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-ink min-h-screen">
      <div className="grain-overlay" aria-hidden="true" />
      <BrowserRouter>
        <ScrollManager />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/make-a-payment" element={<Payment />} />
            <Route path="/customer-care" element={<CustomerCare />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/terms-of-use" element={<Terms />} />
            <Route path="/sitemap" element={<Sitemap />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </main>
        <Footer />
        <MobilePayBar />
      </BrowserRouter>
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;
